export function userDetailsSelector(state) {
  const { id } = userDetailsStateSelector(state)
  return state.entities.users[id]
}

export function userDetailsStateSelector(state) {
  return state.local.currentUser.details
}
